<template>
  <div class="cuenta-corriente-vendedores">
    <b-row>
      <b-col xl="12">
        <b-form>
          <b-card header="Opciones de Consulta">
            <b-form-group
              label="Vendedor"
              label-for="vendedor"
              :label-cols="1"
              horizontal>
              <b-input-group v-if="seleccionVendedor">
                <b-input-group-prepend 
                    class="filter-search-icons" 
                    @click="seleccionarVendedor">
                  <b-input-group-text>
                    <i :class="{ 'fa fa-search': !seleccion.vendedor,
                                  'fa fa-remove': seleccion.vendedor  }"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input 
                  :value="vendedorSeleccionNombre"
                  readonly
                  type="text"/>
              </b-input-group>
              <b-form-input 
                :value="vendedorNombre"
                readonly
                type="text"
                v-if="!seleccionVendedor"/>
            </b-form-group>

            <b-form-group
              label="Desde"
              :label-cols="1"
              horizontal>
              <b-input-group>
                <b-form-input 
                  v-model= "seleccion.fechaDesde" 
                  type="date"
                  v-if="seleccionVendedor">
                </b-form-input>
                <b-form-input 
                  :value= "fechaDesdeSeleccionada | fecha" 
                  readonly
                  type="text"
                  v-if="!seleccionVendedor">
                </b-form-input>
              </b-input-group>
            </b-form-group>

            <b-form-group
              label="Hasta"
              :label-cols="1"
              horizontal>
              <b-input-group>
                <b-form-input 
                  v-model= "seleccion.fechaHasta" 
                  type="date"
                  v-if="seleccionVendedor">
                </b-form-input>
                <b-form-input 
                  :value= "fechaHastaSeleccionada | fecha" 
                  readonly
                  type="text"
                  v-if="!seleccionVendedor">
                </b-form-input>
              </b-input-group>
            </b-form-group>

            <div slot="footer">
              <b-button size="sm" variant="primary" class="footer-button" v-if="!seleccionVendedor"
                @click.prevent="seleccionarOpciones">Seleccionar</b-button>
              <b-button size="sm" variant="primary" class="footer-button" v-if="seleccionVendedor"
                @click.prevent="aceptarSeleccion">Aceptar</b-button>
              <b-button size="sm" variant="danger" class="footer-button" v-if="seleccionVendedor"
                @click.prevent="cancelarSeleccion">Cancelar</b-button>
            </div>
          </b-card>
        </b-form>
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card :header="titulo">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="cuentaCorriente" 
              :fields="cuentaCorrienteFields"
              :current-page="paginaActual"
              :per-page="registrosPorPagina">
            <div slot="table-busy" class="text-center">
              <b-spinner variant="primary" label="Spinning" />
            </div>
            <template v-slot:cell(detailShowing)="row">
              <b-btn class="detailShowing" 
                  size="sm" 
                  @click.stop="row.item._showDetails = !row.item._showDetails">
                {{ row.item._showDetails ? '-' : '+' }}
              </b-btn>            
            </template>            
            <template v-slot:cell(fechaComprobante)="data">
              {{ data.item.fechaComprobante | fecha }}
            </template>
            <template v-slot:cell(debePesos)="data">
              {{ data.item.debePesos | moneda }}
            </template>
            <template v-slot:cell(haberPesos)="data">
              {{ data.item.haberPesos | moneda }}
            </template>
            <template v-slot:cell(saldoAcumuladoPesos)="data">
              {{ data.item.saldoAcumuladoPesos | moneda }}
            </template>
            <template v-slot:cell(debeDolares)="data">
              {{ data.item.debeDolares | moneda('usd') }}
            </template>
            <template v-slot:cell(haberDolares)="data">
              {{ data.item.haberDolares | moneda('usd') }}
            </template>
            <template v-slot:cell(saldoAcumuladoDolares)="data">
              {{ data.item.saldoAcumuladoDolares | moneda('usd') }}
            </template>
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret  v-if="data.item.cancelaSaldo">
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="borrarCancelacionSaldo(data.item)">
                  <i class="fa fa-remove"></i>Borrar Cancelación de Saldos</b-dropdown-item>
              </b-dropdown>
            </template>
            <template v-slot:row-details="row">
              <b-row v-if="comisionesCobros && row.item.cobroId != 0">
                <b-col xl="12">
                  <p class="presupuesto-interno"> Nro. Cobro: {{ row.item.cobroId }}</p>
                  <p class="presupuesto-interno"> Pje. Cobro: {{ row.item.pjeCobro | porcentaje }}</p>
                  <p class="presupuesto-interno"> Total Comisión: {{ row.item.totalPesos | moneda }}</p>
                  <p class="presupuesto-interno"> Total Comisión: {{ row.item.totalDolares | moneda('usd') }}</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col xl="12">
                  <p class="presupuesto-interno"> {{ row.item.presupuestoNumero }} - {{ row.item.presupuestoInterno }} </p>
                </b-col>
              </b-row>
              <b-row v-if="row.item.observaciones != ''">
                <b-col xl="12">
                  <p class="presupuesto-interno">Observaciones: {{ row.item.observaciones }}</p>
                </b-col>
              </b-row>
              <b-row v-if="row.item.cancelaSaldo">
                <b-col xl="12">
                  <p class="presupuesto-interno">(*) Cancela Saldo</p>
                </b-col>
              </b-row>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item
              @click.stop="exportXls">
            <i class="fa fa-file-excel-o"></i>Exportar Movimientos</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <b-modal ref="searchVendedorModal" 
        title="Seleccionar Vendedor"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="search-modal">
      <app-search-vendedor
        @vendedorSeleccionado="vendedorSeleccionado">
      </app-search-vendedor>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>    
  </div>
</template>

<script>
import SearchVendedor from '../vendedores/SearchList.vue'
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'cuentacorrientevendedores/getField',
  mutationType: 'cuentacorrientevendedores/updateField',
});

export default {
  name: 'CuentaCorrienteVendedores',
  components: {
    appSearchVendedor: SearchVendedor,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal
  ],
  props: {
    comisionesCobros: {
      type: Boolean,
      default: false
    }
  },  
  data: () => {
    return {
      cuentaCorrienteFields: [
        {
          key: 'detailShowing',
          label: '',
          class: 'text-center'
        },        
        {
          key: 'fechaComprobante',
          label: 'Fecha Comp.'
        },
        { 
          key: 'tipoComprobante',
          label: 'Tipo de Comp.' 
        },
        { 
          key: 'numeroComprobante',
          label: 'Número' 
        },
        { 
          key: 'clienteProveedor',
          label: 'Ref.' 
        },
        {
          key: 'debePesos',
          label: 'Debe - $',
          class: 'text-right'
        },
        {
          key: 'haberPesos',
          label: 'Haber - $',
          class: 'text-right'
        },
        {
          key: 'saldoAcumuladoPesos',
          label: 'Saldo - $',
          class: 'text-right'
        },
        {
          key: 'debeDolares',
          label: 'Debe - USD',
          class: 'text-right'
        },
        {
          key: 'haberDolares',
          label: 'Haber - USD',
          class: 'text-right'
        },
        {
          key: 'saldoAcumuladoDolares',
          label: 'Saldo - USD',
          class: 'text-right'
        },
        {
          key: 'opciones',
          label: '',
          class: "text-center"
        }        
      ],

      tableBusy: false,
      seleccionVendedor: true,

      seleccion: {
        vendedor: null,
        fechaDesde: '',
        fechaHasta: ''
      }
    }
  },
  computed: {
    ...mapFields([
      'cuentaCorriente',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'fechaDesde',
      'fechaHasta',
      'vendedor',
    ]),
    vendedorNombre: function() {
      return this.vendedor ? this.vendedor.nombre : '';
    },
    fechaDesdeSeleccionada: function() {
      return this.vendedor ? this.fechaDesde : '1900-01-01';
    },
    fechaHastaSeleccionada: function() {
      return this.vendedor ? this.fechaHasta : '1900-01-01';
    },
    vendedorSeleccionNombre: function() {
      return this.seleccion.vendedor ? this.seleccion.vendedor.nombre : '';
    },
    titulo() {
      if (this.comisionesCobros) {
        return 'Cuenta Corriente de Vendedores por Cobros';
      }
      return 'Cuenta Corriente de Vendedores';
    }
  },
  created() {
    this.inicializar();
  },  
  methods: {
    inicializar() {
      this.$store.dispatch('cuentacorrientevendedores/inicializarOpciones')
        .then(() => {
          this.seleccion.fechaDesde = this.fechaDesde;
          this.seleccion.fechaHasta = this.fechaHasta;
        })
        .catch(error => this.showErrorMsj(error));
    },
    getItems() {
      let dispatch = 'cuentacorrientevendedores/getCuentaCorriente';
      if (this.comisionesCobros) {
        dispatch = 'cuentacorrientevendedores/getCuentaCorrienteByCobros';
      }

      this.tableBusy = true;
      this.$store.dispatch(dispatch)
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    seleccionarOpciones () {
      this.seleccion.vendedor = this.vendedor;
      this.seleccion.fechaDesde = this.fechaDesde;
      this.seleccion.fechaHasta = this.fechaHasta;
      this.seleccionVendedor = true;
    },
    seleccionarVendedor() {
      if (this.seleccion.vendedor) {
        this.seleccion.vendedor = null;
      } else {
        this.$refs.searchVendedorModal.show();
      }
    },
    cancelarSeleccionVendedor() {
      this.seleccion.vendedor = null;
    },
    vendedorSeleccionado(item) {
      this.$refs.searchVendedorModal.hide();
      this.seleccion.vendedor = item;
    },
    aceptarSeleccion() {
      this.fechaDesde = this.seleccion.fechaDesde;
      this.fechaHasta = this.seleccion.fechaHasta;
      this.vendedor = this.seleccion.vendedor;
      this.seleccionVendedor = false;
      this.paginaActual = 1;
      this.getItems();
    },
    cancelarSeleccion() {
      this.seleccionVendedor = false;
    },
    borrarCancelacionSaldo(item) {
      const params = {
        presupuestoInternoId: item.presupuestoInternoId,
        vendedorComisionCancelacionId: item.comprobanteId
      } 

      this.showModalConfirm('¿Desea borrar la cancelación de saldos seleccionada?', 
        this.borrarCancelacion.bind(this, params), 'Si', null, 'No')      
    },
    borrarCancelacion(params) {
      this.showSpinner();
      this.$store.dispatch('cuentacorrientevendedores/delete', params)
        .then(() => this.getItems())
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());      
    },
    exportXls () {
      let exportRpt = Boolean(false); 

      if (this.cuentaCorriente) {
        if (this.cuentaCorriente.length != 0) {
          exportRpt = Boolean(true);
        }
      }
      if (exportRpt) {
        let title= 'Cuenta Corriente';
        let fileName = 'cuenta-corriente-vendedores';
        let format = [
          { titulo: 'Fecha Comp.', nombre: 'fechaComprobante', formato: 'fechaComprobante' },
          { titulo: 'Tipo Comp.', nombre: 'tipoComprobante', formato: '' },
          { titulo: 'Nro.Comp.', nombre: 'numeroComprobante', formato: '' },
          { titulo: 'Ref.', nombre: 'clienteProveedor', formato: '' },
          { titulo: 'Nro.Presupuesto', nombre: 'presupuestoNumero', formato: '' },
          { titulo: 'Presupuesto', nombre: 'presupuestoInterno', formato: '' },
          { titulo: 'Debe $', nombre: 'debePesos', formato: '' },
          { titulo: 'Haber $', nombre: 'haberPesos', formato: '' },
          { titulo: 'Saldo $', nombre: 'saldoAcumuladoPesos', formato: '' },
          { titulo: 'Debe USD', nombre: 'debeDolares', formato: '' },
          { titulo: 'Haber USD', nombre: 'haberDolares', formato: '' },
          { titulo: 'Saldo USD', nombre: 'saldoAcumuladoDolares', formato: '' },
          { titulo: 'Observaciones', nombre: 'observaciones', formato: '' },
        ];

        this.exportXLS(title, fileName, this.cuentaCorriente, format);        
      } else {
        this.showModalMsj('No hay datos para exportar', null, null, 'light');
      }
    }

  },
  watch: {
    'comisionesCobros'() {
      this.inicializar();
    }
  }   
}
</script>

<style>
  .cuenta-corriente-vendedores .registro tr > td {
    padding-top: 0.5rem;
    padding-bottom: 0.25rem;
  }
  .cuenta-corriente-vendedores .registro tr > td .btn.detailShowing {
    padding-top: 0;
  }
  .cuenta-corriente-vendedores .registro p.presupuesto-interno {
    padding-left: 25px;
    margin-bottom: 0.5rem;
  }
  .cuenta-corriente-vendedores .registro table td[aria-colindex="1"] {
    width: 35px;
  }
</style>
